import React from 'react'

import {
  useGetSelectEscapeIndexesQuery,
  GetBucketListItemsQueryResult,
} from '../../hooks/useQueries'

import Button from '../../components/display/Button'
import { Grid, GridItem } from '../../components/layout/ItemGrid'

import BucketListItem from './BucketListItem'
import { EmptyResults, EmptyBody } from './Empty'
import { SeeMoreButtonWrapper, Subheading, Loader } from './shared'

type BucketListItemNode = GetBucketListItemsQueryResult['data']['bucketList']['items']['edges'][0]['node']

type BucketListItemsProps = {
  publicBucketlist?: boolean
  accommodationNodes: BucketListItemNode[]
  adventuresNodes: BucketListItemNode[]
  accommodationLoading: boolean
  adventuresLoading: boolean
  accommodationHasNextPage: boolean
  adventuresHasNextPage: boolean
  handleSeeMoreAccommodation: () => any
  handleSeeMoreAdventures: () => any
  bucketListLoading: boolean
  bucketListEmpty: boolean
  noMatchingAccommodationOnly?: boolean
  noMatchingItemsOfAnyKind?: boolean
  handleResetFilters: () => any
}

const Items = ({
  publicBucketlist,
  accommodationLoading,
  accommodationNodes,
  accommodationHasNextPage,
  handleSeeMoreAccommodation,
  adventuresLoading,
  adventuresNodes,
  adventuresHasNextPage,
  handleSeeMoreAdventures,
  bucketListLoading,
  bucketListEmpty,
  noMatchingAccommodationOnly,
  noMatchingItemsOfAnyKind,
  handleResetFilters,
}: BucketListItemsProps) => {
  const { data: selectEscapeIndexesData } = useGetSelectEscapeIndexesQuery()
  const bucketListItemsIndex = selectEscapeIndexesData?.currentUser
    ?.bucketListItemsIndex as GQL_BucketListItemsIndex
  const bookingAdventuresIndex = selectEscapeIndexesData?.currentUser
    ?.bookingAdventuresIndex as GQL_BookingAdventuresIndex

  return (
    <div>
      <Grid className="bucketlist">
        {!accommodationLoading && accommodationNodes?.length > 0 && (
          <>
            <Subheading>Places to stay</Subheading>
            {accommodationNodes.map(({ item, pricing }) => {
              return (
                <GridItem key={`${item.__typename}:${item.id}`}>
                  <BucketListItem
                    item={item}
                    pricing={pricing}
                    bookingAdventuresIndex={bookingAdventuresIndex}
                    bucketListItemsIndex={bucketListItemsIndex}
                  />
                </GridItem>
              )
            })}

            {noMatchingAccommodationOnly && (
              <EmptyResults
                type="accommodation"
                onResetFilters={handleResetFilters}
              />
            )}

            {accommodationHasNextPage && (
              <SeeMoreButtonWrapper>
                <Button onClick={handleSeeMoreAccommodation} ghost>
                  see more
                </Button>
              </SeeMoreButtonWrapper>
            )}
          </>
        )}

        {!accommodationLoading && // do not show while accom is loading, or this loads a split second earlier and jumps
          !adventuresLoading &&
          adventuresNodes?.length > 0 && (
            <>
              <Subheading>Things to do</Subheading>
              {adventuresNodes.map(({ item, pricing }) => {
                return (
                  <GridItem key={`${item.__typename}:${item.id}`}>
                    <BucketListItem
                      item={item}
                      pricing={pricing}
                      bookingAdventuresIndex={bookingAdventuresIndex}
                      bucketListItemsIndex={bucketListItemsIndex}
                    />
                  </GridItem>
                )
              })}

              {adventuresHasNextPage && (
                <SeeMoreButtonWrapper>
                  <Button onClick={handleSeeMoreAdventures} ghost>
                    see more
                  </Button>
                </SeeMoreButtonWrapper>
              )}
            </>
          )}

        {noMatchingItemsOfAnyKind && (
          <EmptyResults onResetFilters={handleResetFilters} />
        )}

        {bucketListEmpty && <EmptyBody publicBucketlist={publicBucketlist} />}

        {(bucketListLoading || accommodationLoading || adventuresLoading) && (
          <Loader />
        )}
      </Grid>
    </div>
  )
}

export default Items
